import React from 'react';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';

export default ({novel_id, name, cata}) => (
<div style={{
    height: '20px',
    position: 'relative',
    fontSize: '14px',
    lineHeight: '20px',
}}>
    <Link to={`/book/detail/${novel_id}`}>
    <div style={{
        color: '#999999',
        float: 'left',
    }}>[{cata}]</div>
    <div style={{
        paddingLeft: '4px',
        color: '#333333',
        overflow: 'hidden',
    }}>
		<LinesEllipsis text={name} maxLine={1} />
    </div>
    </Link>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_4.js